<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-09-10 10:38:28
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 16:21:04
-->
<template>
  <ux-form
    class="bind-access x-padding-x"
    ref="form"
    :data="formData"
    :rules="rules"
    label-width="80px"
    data-automation="bindAccess"
    :colon="true"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.unbindApply.name')">{{ data.name }}</ux-form-item>
    <ux-form-item :label="$t('HT.router.productList')" prop="product_id">
      <ux-select
        v-model="formData.product_id"
        :options="list"
        :props="{ label: 'name', value: 'id' }"
        :disabled="disList"
        :placeholder="this.$t('HT.bindProduct.name.placeholder')"
      ></ux-select>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      formData: {
        app_id: this.data.id, // id
        product_id: '' // 产品id
        // start_time: '', // 开始时间
        // end_time: '', // 结束时间
      },
      disList: [], // 禁用的数组
      rules: this.$rul.bindProduct()
    };
  },

  created() {
    for (let i = 0; i < this.list.length; i++) {
      if (!this.list[i]['published']) {
        // 未上线
        this.disList.push(this.list[i]['id']);
      }
    }
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }

    /**
     * 时间选择
     * @param {Object} params 查询对象
     */
    // change(val) {
    //     if (val) {
    //         this.formData.start_time = val[0]+ ' 00:00:00';
    //         this.formData.end_time = val[1]+ ' 23:59:59';
    //     }
    // }
  }
};
</script>
